$('.tego-truncate').truncate(170, ' ');
$('.tego-truncate-conseil').truncate(200, ' ');